<template>
    <div>
        <el-dialog
            :modal-append-to-body="false"
            append-to-body
            title="标识码"
            :visible.sync="show"
            width="25cm"
            :style="{minWidth:'25cm'}"
           
            :before-close="handleClose">
            <div class="dialog-footer" v-loading="loading" >
                <el-button @click="show = false">取 消</el-button>
                <el-button style="margin-left:10px" type="primary"   @click="print">打 印</el-button>
            </div>
            <div ref="print" id="qrcodeBox" v-loading="loading" 
            v-if="show">
                <div id="printBox">
                    <div class="page" id="page">
                        <div id="qrcode" style=" flex-wrap: wrap; display: flex;width:100%;" class="qrcode">
                    
                        </div>
                    </div>
               </div>
            </div>
            
        </el-dialog>
    </div>
</template>
<style scoped>
    .page
        {
            width: 21cm;
            height: 29.7cm;
            padding: 3.5mm;
            margin: 0 auto;
            border: 1px #D3D3D3 solid;
            border-radius: 5px;
            background: white;
            overflow: hidden;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
        }
        .dialog-footer{
            text-align: right;
            margin-bottom: 20px;
        }
        @page
        {
            size: A4;
            margin: 0;
        }
        @media print
        {
            *{
                padding: 0px;
                margin: 0px;
            }
            .page
            {   
                margin: 0;
                border: initial;
                border-radius: initial;
                width: initial;
                min-height: initial;
                box-shadow: initial;
                background: initial;
                page-break-after: always;
            }
        }
</style>
<script>
import request from '@/util/request';
import qrcode from 'qrcodejs2';
import JsBarcode from 'jsbarcode'
const getQrcode = (params, options) =>
request.post('/api/mark/manage/addresses', params,options);
export default {
    data(){
        return{
           
            loading:false,
            show:false,
            qrcodeList:[],
            moduleType:'',
            codePicHeight:'',//标识码设置的高
            codePicWidth:'',//标识码设置的宽
            oneCodeShowHeight:'',//一个标识码实际的高
            oneCodeShowWidth:'',//一个标识码实际的宽
            pageHeight:'',//一页高
            pageWidth:'',//一页宽
            qrcodeWidth:'',//一页去掉上下边距宽
            qrcodeHeight:'',//一页去掉上下边距高
            pageAmount:0,//一页可展示标识码数量
            

        }
    },
    created(){
       
    },
    methods:{
        // 打印方法
        print(){
            this.show = false;
            Print('#qrcodeBox', {
                onStart: function () {
                console.log('onStart', new Date())
                },
                onEnd: function () {
                console.log('onEnd', new Date())
                }
            })
        },
        // 创建二维码方法
        createdQrcode(){
            let flag = document.createDocumentFragment();
            let count = 0;
            let page = document.createElement('div');
            page.setAttribute("class",'page');
            page.setAttribute("id",'page');
            page.style=`width: 21cm;
            height: 29.7cm;
            padding: 3.5mm;
            padding-top:3.6mm;
            margin: 0 auto;
            border: 1px #D3D3D3 solid;
            border-radius: 5px;
            background: white;
            overflow: hidden;
            box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
            `
            
            let qrcodePageAll = document.createElement('div');
            qrcodePageAll.style = ' flex-wrap: wrap; display: flex;';
            this.qrcodeList.forEach(item=>{
                
                if(count==16){
                    count = 0;
                    page = document.createElement('div');
                    page.setAttribute("class",'page');
                    page.style=`width: 21cm;
                    height: 29.7cm;
                    padding: 3.5mm;
                    padding-top:3.6mm;
                    margin: 0 auto;
                    border: 1px #D3D3D3 solid;
                    border-radius: 5px;
                    background: white;
                    overflow: hidden;
                    box-shadow: 0 0 5px rgba(0, 0, 0, 0.1);
                    `
                    qrcodePageAll = document.createElement('div');
                    qrcodePageAll.style = ' flex-wrap: wrap; display: flex;';
                }
                count = count+1;
                var box = document.createElement('div');
                // box.style = "margin:10px;padding:10px;border:1px solid #000;display:flex;width:"+this.qrcodeWidth+'px';
                box.style = "margin:0 1px;margin-bottom:1px;padding:2px 10px;border:1px solid #000;font-size:12px; display:flex;height:3.53cm;width:9.85cm;"+ (this.qrcodeWidth/2 - 2)+'px';
                var left = document.createElement('div');
                // left.style="height:180px;line-height:180px";
                var qrcodeItemdiv = document.createElement('div');
                // qrcodeItemdiv.style="margin:0 10px;"
                var qrcodeItem = new qrcode(qrcodeItemdiv, {
                    text: item.urlPath,
                    width: this.codePicWidth,
                    // width:100,
                    // height:100,
                    height: this.codePicHeight,
                    colorDark: '#000000',
                    colorLight: '#ffffff',
                    correctLevel: qrcode.CorrectLevel.H,
                });
                qrcodeItemdiv.style="margin-right:10px;margin-top:5px"
                left.appendChild(qrcodeItemdiv)
                var right = document.createElement('div');

                var title = document.createElement('div');
                if(this.moduleType==0){
                    title.innerHTML="设备名称";
                }else if(this.moduleType==1){
                    title.innerHTML="区域名称";
                }
                // title.style = "color:#333;font-weight:900";
                right.appendChild(title);

                var text = document.createElement('div');
                text.innerHTML=item.name || '' ;
                text.style = "color:#333;font-weight:900;min-height:17px;min-width:50px;";
               
                right.appendChild(text);


                var title = document.createElement('div');
                if(this.moduleType==0){
                    title.innerHTML="设备类型";
                }else if(this.moduleType==1){
                    title.innerHTML="区域类型";
                }
                // title.style = "color:#333;font-weight:900";
                right.appendChild(title);

                var text = document.createElement('div');
                text.innerHTML=item.typeName || ' ';
                text.style = "color:#333;font-weight:900;min-height:17px;min-width:50px;";
                
                right.appendChild(text);

                var title = document.createElement('div');
                title.innerHTML="所属部门";
                // title.style = "color:#333;font-weight:900";
                right.appendChild(title);

                var text = document.createElement('div');
                text.innerHTML=item.deptName || ' ';
                text.style = "color:#333;font-weight:900;min-height:17px;min-width:50px;";
              
                right.appendChild(text);

                var title = document.createElement('div');
                title.innerHTML="所属班组";
                // title.style = "color:#333;font-weight:900";
                right.appendChild(title);

                var text = document.createElement('div');
                text.innerHTML=item.shiftName || ' ';
                text.style = "color:#333;font-weight:900;min-height:17px;min-width:50px;";
               
                right.appendChild(text);



               
                
                box.appendChild(left);
                box.appendChild(right);
               
                // box.appendChild(name);
                // box.appendChild(code);
                
                qrcodePageAll.append(box);
                page.append(qrcodePageAll);
                
                flag.appendChild(page);
               
            })
            // console.log(box.offsetWidth)
                // console.log(box.offsetHeight)
            console.log(document.querySelector("#printBox"))
           
            // document.createElement('div');
            setTimeout(()=>{
                this.$nextTick(()=>{
                     document.querySelector("#printBox").innerHTML = '' ;
                    document.querySelector("#printBox").appendChild(flag)
                })

            },100)
            this.loading = false;
        },
        // 创建条形码方法
        createdBarcode(){
            let flag = document.createDocumentFragment();
            this.qrcodeList.forEach(item=>{
                var box = document.createElement('div');
                box.style = "margin:10px;padding:10px;border:1px solid #000;";
                var svg = document.createElement('img');
                svg.style="margin:0 10px";
                JsBarcode(svg,item.urlPath,{
                    width:1,
                    displayValue:false,
                    height: this.codePicHeight,
                });
                svg.setAttribute("width",this.codePicWidth);
                var name = document.createElement('div');
                name.style="font-weight:bold;text-align:center;margin:5px 0"
                name.innerHTML = item.name;
                var code = document.createElement('div');
                code.style = "text-align:center;"
                code.innerHTML = item.codeNo;
                box.appendChild(svg);
                box.appendChild(name);
                box.appendChild(code);
                flag.appendChild(box);
               
            })

            document.querySelector("#qrcode").innerHTML = '' ;
            document.querySelector("#qrcode").appendChild(flag);
            this.loading = false;
        },
        // 获得数据请求方法
        getQrcodes(projectId,moduleType,items){
            this.show = true;
            this.loading = true;
            let ids = '';
            items.forEach(item=>{
                ids += item.id +','; 
            })
            setTimeout(()=>{
                if(!this.qrcodeWidth){
                    // 获取一页A4纸张的高宽
                    let page = document.getElementById('page');
                    let pageWidth = page.offsetWidth;
                    let pageHeight = page.offsetHeight
                    
                    // 获取A4纸张打印内容宽高 （去掉边距）
                    let qrcode = document.getElementById('qrcode');
                    let qrcodeWidth = qrcode.offsetWidth;
                    //  (pageWidth - qrcodeWidth)边距的宽度
                    let qrcodeHeight =pageHeight - (pageWidth - qrcodeWidth);

                    this.qrcodeWidth = qrcodeWidth-1;
                    this.qrcodeHeight = qrcodeHeight-1;
                }
                getQrcode({
                    projectId:projectId,
                    moduleType:moduleType,
                    ids: ids

                }).then(res=>{
                    this.moduleType = res.data.moduleType;//判断二维码类型 0：设备 1：区域
                    this.qrcodeList = res.data.codePicList || 1; //1 二维码 2条形码
                    // this.codePicHeight = res.data.codePicHeight || 150;
                    // this.codePicWidth = res.data.codePicWidth || 150;
                    this.codePicHeight = 110; // 二维码高
                    this.codePicWidth = 110; //二维码宽
                    this.oneCodeShowHeight = this.codePicHeight + 64; //一个二维码二维码整体高
                    this.oneCodeShowWidth  = this.codePicWidth + 42;//一个二维码二维码整体宽
                    this.oneCodeShowHeight = 200;
                    this.oneCodeShowWidth  = this.qrcodeWidth/2 - 32;
                    // this.pageAmount = Math.floor(this.qrcodeWidth/this.oneCodeShowWidth) * Math.floor(this.qrcodeHeight/this.oneCodeShowHeight)
                    this.pageAmount = 16; //一页打印数量
                    console.log(this.pageAmount)


                    this.createdQrcode();
                    if(res.data.codePicType==1){
                        
                    }else if(res.data.codePicType==2){
                        // this.createdBarcode();
                        this.show = false;
                        this.loading = false;
                        return
                    }
                    
                    
                    
                }) 
                

               


            },100)
           
            
        }
    }
}
</script>
